import { FC } from 'react'
import s from './index.module.scss'
import firstImage from './boarding.jpg'
import secondImage from './seats.jpg'
import thirdImage from './plane.jpg'

const data = [
  {
    image: firstImage,
    alt: 'boarding',
    description: <>Book individual seats at accessible prices by joining a flight or initiating your own flight. Crowdfunding puts the power in the palms of the flyer.<br/><br/>No lines. No crowded terminals. No frustration. Arrive just 30 minutes before take-off and be escorted to your jet.</>,
  },
  {
    image: secondImage,
    alt: 'seats',
    description: <>Board one of our jets and join other entrepreneurs, creators an innovators traveling to Austin for one of the world’s largest conferences to meet and exchange ideas.</>,
  }
  ,
  {
    image: thirdImage,
    alt: 'laptop',
    description: <>XO utilizes data science to predict supply and demand and offer a private jet experience at 1/10th of the price and a more sustainable approach to flying private. All flights can be searched online or in our XO mobile app and booked directly.</>,
  },
]

const SharedBenefits: FC = () => {
  return (
    <div className={s.root}>
      <h2 className={s.title}>
        Crowdfund a flight to Austin.
      </h2>
      <div className={s.list}>
        {data.map((item, index) => {
          return (
          <div key={index} className={s.items}>
            <div className={s.image}>
              <img alt={item.alt} src={item.image} />
            </div>
            <p className={s.text}>
              {item.description}
            </p>
          </div>
        )})}
      </div>
    </ div>
  )
}

export default SharedBenefits
